(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pn-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select', function (event) {
  var item = event.target.closest('.pn-faq-item');
  if (item) item.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select', function (event) {
  var card = event.target.closest('.pn-review-card');
  if (card) card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-video-strip"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select', function (event) {
  var card = event.target.closest('.pn-video-card');
  if (card) card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
});

  } catch(e) { console.error(e); }
})();
})();
